<div class="composer-container" style="padding: 20px;">
    
    <nz-card class="shadow-sm" style="margin-bottom: 24px;" nzTitle="Configure SDK Email">
        
        <div nz-row [nzGutter]="16">
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired>Customer Name</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input [(ngModel)]="emailData.customerName" placeholder="Customer / Company name" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired>Customer Email</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input [(ngModel)]="emailData.customerEmail" type="email" placeholder="customer@company.com" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzTooltipTitle="Add multiple emails separated by commas">CC Emails</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input [(ngModel)]="emailData.customerCcEmail" placeholder="cc1@domain.com, cc2@domain.com" />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row [nzGutter]="16" style="margin-bottom: 16px;">
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired nzTooltipTitle="Set the expiry date in days for the links within the email">Link Expiry</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-select [(ngModel)]="emailData.expiry" style="width: 100%;">
                            <nz-option [nzValue]="7" nzLabel="7 Days"></nz-option>
                            <nz-option [nzValue]="14" nzLabel="14 Days"></nz-option>
                            <nz-option [nzValue]="21" nzLabel="21 Days"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            
            <div nz-col nzSpan="16" style="padding-top: 32px;">
                <nz-space nzSize="large">
                    <label *nzSpaceItem nz-checkbox [(ngModel)]="emailData.ccSales">
                        cc BioRugged Sales
                    </label>
                    <label *nzSpaceItem nz-checkbox [(ngModel)]="emailData.ccSupport">
                        cc BioRugged Support
                    </label>
                </nz-space>
            </div>
        </div>
        

        <nz-divider></nz-divider>

        <div nz-row [nzGutter]="16">
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24">1. Select Product</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-select 
                            [ngModel]="selectedProduct" 
                            (ngModelChange)="onProductChange($event)"
                            nzPlaceHolder="Choose a product"
                            [nzLoading]="isLoadingProducts"
                            nzShowSearch
                            style="width: 100%;">
                            @for (p of products; track p.id) {
                                <nz-option [nzValue]="p" [nzLabel]="p.name ?? ''"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24">2. Select Packages</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-select 
                            nzMode="multiple"
                            [(ngModel)]="selectedPackageIds"
                            nzPlaceHolder="Choose one or more packages"
                            [nzLoading]="isLoadingPackages"
                            [nzDisabled]="!selectedProduct || packagesForProduct.length === 0"
                            style="width: 100%;">
                            @for (pkg of packagesForProduct; track pkg.id) {
                                <nz-option [nzValue]="pkg.id" [nzLabel]="pkg.name ?? ''"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div style="margin-top: 16px; text-align: right;">
            <nz-space>
                <button *nzSpaceItem 
                        nz-button 
                        nzType="default" 
                        [nzLoading]="isLoadingLinks" 
                        [disabled]="selectedPackageIds.length === 0 || !emailData.customerName || !emailData.customerEmail"
                        (click)="loadData()">
                    Generate Email Draft
                </button>
                <button *nzSpaceItem 
                        nz-button 
                        nzType="primary" 
                        [disabled]="!isFormValid()"
                        (click)="sendEmail()">
                    Send Email
                </button>
            </nz-space>
        </div>
    </nz-card>

    <nz-card class="shadow-sm" style="margin-bottom: 16px;" nzTitle="Email Preview">
        <p nz-typography>
            @if (emailData.customerName) {
                Dear <strong>{{ emailData.customerName }}</strong>,
            } @else {
                Dear Customer,
            }
        </p>

        <p nz-typography>
            Thank you for choosing BioRugged. Below are the download links for the SDK packages you requested. These links provide direct, secure access to the required files.
        </p>

        @if (generatedPassword) {
            <div style="background-color: #e6f7ff; border: 1px solid #91d5ff; padding: 16px; border-radius: 6px; margin: 16px 0;">
                <span nz-typography>
                    <strong>Secure Download Password:</strong> 
                    <span style="font-family: monospace; font-size: 1.2em; margin-left: 8px; color: #0050b3;">
                        {{ generatedPassword }}
                    </span>
                </span>
                <br>
                <span nz-typography nzType="secondary" style="font-size: 0.85em;">
                    You will be prompted to enter this password when clicking the download links below.
                </span>
            </div>
        }

        <nz-divider></nz-divider>

        @if (emailData.packages.length > 0 && emailData.packages[0].product) {
            <div style="display: flex; gap: 20px; align-items: flex-start; background: #fafafa; padding: 20px; border-radius: 8px; margin-bottom: 32px; border: 1px solid #f0f0f0;">
               
                @if (emailData.packages[0].product.logoBase64) {
                    <img [src]="emailData.packages[0].product.logoBase64" alt="Product Logo" style="max-width: 140px; object-fit: contain; border-radius: 4px;" />
                }
                
                <div style="flex: 1;">
                    <h3 nz-typography style="margin-top: 0; color: #1890ff;">{{ emailData.packages[0].product.name }}</h3>
                    <p nz-typography nzType="secondary">{{ emailData.packages[0].product.description }}</p>
                    
                    <nz-space nzSize="middle" style="margin-top: 12px;">
                        @if (emailData.packages[0].product.brochureDriveFile) {
                            <a *nzSpaceItem nz-button nzType="primary" nzGhost [href]="emailData.packages[0].product.brochureDriveFile.driveFileLink" target="_blank">
                                <span nz-icon nzType="file-pdf"></span> Brochure
                            </a>
                        }
                        @if (emailData.packages[0].product.datasheetDriveFile) {
                            <a *nzSpaceItem nz-button nzType="primary" nzGhost [href]="emailData.packages[0].product.datasheetDriveFile.driveFileLink" target="_blank">
                                <span nz-icon nzType="file-text"></span> Datasheet
                            </a>
                        }
                    </nz-space>
                </div>
            </div>
        }

        @for (pkg of emailData.packages; track pkg.id) {
            <div class="package-block" style="margin-bottom: 32px;">
                <h4 nz-typography>{{ pkg.name }}</h4>
                
                @if (pkg.description) {
                    <p nz-typography nzType="secondary" style="margin-top: -8px; margin-bottom: 16px;">
                        {{ pkg.description }}
                    </p>
                }

                <nz-list nzBordered nzSize="small">
                    @for (sdk of pkg.sdks; track sdk.id) {
                        
                        <nz-list-item>
                            <div style="width: 100%;">
                                <div style="display: flex; justify-content: space-between; align-items: center;">
                                    <div>
                                        <span nz-typography><strong>{{ sdk.name }}</strong></span>
                                        
                                        <div style="margin-left: 8px; display: inline-block;">
                                            @for (platform of sdk.platforms; track platform) {
                                                <nz-tag [nzColor]="'blue'">{{ platform }}</nz-tag>
                                            }
                                        </div>
                                    </div>
                                </div>

                                @if (getAssetsList(sdk, SdkAssetTypeEnum.Src).length > 0 || 
                                    getAssetsList(sdk, SdkAssetTypeEnum.Documentation).length > 0 || 
                                    getAssetsList(sdk, SdkAssetTypeEnum.Lib).length > 0 || 
                                    getAssetsList(sdk, SdkAssetTypeEnum.Demo).length > 0) {
                                    
                                    <div style="margin-top: 8px; padding-top: 8px; border-top: 1px dashed #f0f0f0;">

                                        @if (getAssetsList(sdk, SdkAssetTypeEnum.Src).length > 0) {
                                            <div style="margin-bottom: 4px;">
                                                <span nz-typography nzType="secondary" style="font-size: 12px; margin-right: 8px; display: inline-block; width: 100px;">Source:</span>
                                                <nz-space nzSize="small" nzWrap>
                                                    @for (doc of getAssetsList(sdk, SdkAssetTypeEnum.Src); track doc.id) {
                                                        <a *nzSpaceItem [href]="doc.driveFileLink" target="_blank" style="font-size: 13px; color: #941adb;">
                                                            <span nz-icon nzType="book" style="margin-right: 4px;"></span>{{ doc.driveFileName }}
                                                        </a>
                                                    }
                                                </nz-space>
                                            </div>
                                        }
                                        
                                        @if (getAssetsList(sdk, SdkAssetTypeEnum.Documentation).length > 0) {
                                            <div style="margin-bottom: 4px;">
                                                <span nz-typography nzType="secondary" style="font-size: 12px; margin-right: 8px; display: inline-block; width: 100px;">Documentation:</span>
                                                <nz-space nzSize="small" nzWrap>
                                                    @for (doc of getAssetsList(sdk, SdkAssetTypeEnum.Documentation); track doc.id) {
                                                        <a *nzSpaceItem [href]="doc.driveFileLink" target="_blank" style="font-size: 13px; color: #52c41a;">
                                                            <span nz-icon nzType="book" style="margin-right: 4px;"></span>{{ doc.driveFileName }}
                                                        </a>
                                                    }
                                                </nz-space>
                                            </div>
                                        }

                                        @if (getAssetsList(sdk, SdkAssetTypeEnum.Lib).length > 0) {
                                            <div style="margin-bottom: 4px;">
                                                <span nz-typography nzType="secondary" style="font-size: 12px; margin-right: 8px; display: inline-block; width: 100px;">Libraries:</span>
                                                <nz-space nzSize="small" nzWrap>
                                                    @for (lib of getAssetsList(sdk, SdkAssetTypeEnum.Lib); track lib.id) {
                                                        <a *nzSpaceItem [href]="lib.driveFileLink" target="_blank" style="font-size: 13px; color: #1890ff;">
                                                            <span nz-icon nzType="folder" style="margin-right: 4px;"></span>{{ lib.driveFileName }}
                                                        </a>
                                                    }
                                                </nz-space>
                                            </div>
                                        }

                                        @if (getAssetsList(sdk, SdkAssetTypeEnum.Demo).length > 0) {
                                            <div>
                                                <span nz-typography nzType="secondary" style="font-size: 12px; margin-right: 8px; display: inline-block; width: 100px;">Demos:</span>
                                                <nz-space nzSize="small" nzWrap>
                                                    @for (demo of getAssetsList(sdk, SdkAssetTypeEnum.Demo); track demo.id) {
                                                        <a *nzSpaceItem [href]="demo.driveFileLink" target="_blank" style="font-size: 13px; color: #faad14;">
                                                            <span nz-icon nzType="play-square" style="margin-right: 4px;"></span>{{ demo.driveFileName }}
                                                        </a>
                                                    }
                                                </nz-space>
                                            </div>
                                        }

                                    </div>
                                }
                            </div>
                        </nz-list-item>
                        
                    } @empty {
                        <nz-list-item>
                            <span nz-typography nzType="danger">
                                <em>No SDK files are currently assigned to this package.</em>
                            </span>
                        </nz-list-item>
                    }
                </nz-list>
            </div>
        } @empty {
            <nz-empty nzNotFoundContent="Generate a draft to see the email preview."></nz-empty>
        }

        <nz-divider></nz-divider>
        
        <p nz-typography nzType="secondary">
            If you experience any issues accessing these files, please reply to this email or contact support.
        </p>
        <p nz-typography>
            Best regards,<br>The SDK Manager Team
        </p>
    </nz-card>
</div>